import { Form, Radio } from 'antd';

import { AddMinimizerOptions } from '../SinkInfoModal/SinkInfoModal.component';
import * as St from './ChipMinimizerInfoContent.styles';

import { IMAGE_COMING_SOON } from '~/core/constants';
import { DesignSection } from '~/core/enums';
import { useGetDesignSectionTranslations } from '~/core/hooks/useGetDesignSectionTranslations';
import { OptionalProduct } from '~/core/models';
import { formatPriceUnitOrFree, imgUrl } from '~/core/utils';
import CommonRadio from '~atoms/CommonRadio';

type ChipMinimizerInfoContentProps = {
  chipMinimizer?: OptionalProduct;
  setMinimizerOption: (value: AddMinimizerOptions) => void;
};

const ChipMinimizerInfoContent = ({
  chipMinimizer,
  setMinimizerOption,
}: ChipMinimizerInfoContentProps) => {
  const [form] = Form.useForm();

  const {
    chipMinimizerDescription,
    chipMinimizerModify,
    chipMinimizerNoChipMinimizer,
  } = useGetDesignSectionTranslations(DesignSection.SINKS, [
    'CHIP_MINIMIZER.DESCRIPTION',
    'CHIP_MINIMIZER.MODIFY',
    'CHIP_MINIMIZER.NO_CHIP_MINIMIZER',
  ]);

  return (
    <St.Container>
      <St.Title>CHIP MINIMIZER</St.Title>
      <St.PriceWrapper>
        <St.ImageWrapper>
          <St.Price>
            {formatPriceUnitOrFree(chipMinimizer?.price, null, true)}
          </St.Price>
          <St.Image
            src={imgUrl(chipMinimizer?.imageUrl || IMAGE_COMING_SOON, 300)}
            alt={chipMinimizer?.name || 'chip minimizer'}
          />
        </St.ImageWrapper>
      </St.PriceWrapper>
      <p>{chipMinimizerDescription}</p>
      <Form form={form} layout="vertical">
        <Form.Item>
          <CommonRadio
            defaultValue="add"
            onChange={(e) => setMinimizerOption(e.target.value)}
          >
            <Radio value="add">{chipMinimizerModify}</Radio>
            <Radio value="decline">{chipMinimizerNoChipMinimizer}</Radio>
          </CommonRadio>
        </Form.Item>
      </Form>
    </St.Container>
  );
};

export default ChipMinimizerInfoContent;
